import { render } from "./ContactUsMessages.vue?vue&type=template&id=f1d7e878"
import script from "./ContactUsMessages.vue?vue&type=script&lang=js"
export * from "./ContactUsMessages.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__